import { createListReducer } from "./base-reducer";
import BankAccountActions from "../constants/actions";
import { BankAccountRecord } from "./../records";

const listReducer = createListReducer(BankAccountActions.BANK_ACCOUNTS.LIST, BankAccountRecord);
const createUpdateReducer = createListReducer(BankAccountActions.BANK_ACCOUNTS.ACCOUNT, BankAccountRecord);

export default (state, action) => {
    return [
        listReducer,
        createUpdateReducer
    ].reduce((state, reducer) => reducer(state, action), state);
};